import { truck } from "./lib/truck";
import { url } from "./lib/url";
import { literals } from "./lib/literals";
import { trip } from "./lib/trip";
import { topic } from "./lib/topic";
import { chat } from "./lib/chat";
import { employee } from "./lib/employee";
import { customer } from "./lib/customer";
import { localStorage } from "./lib/localStorage";
import { roleRestrictions } from "./lib/roleRestrictions";
import { accessControl } from "./lib/access";


export const constants = {
    ...url,
    ...truck,
    ...literals,
    ...trip,
    ...topic,
    ...chat,
    ...employee,
    ...customer,
    ...roleRestrictions,
    ...localStorage,
    ...accessControl
}